/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'temperature': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.4 70.8',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M19.64 46.55V6.84a6.44 6.44 0 0 0-12.89 0v39.71a12.8 12.8 0 1 0 12.89 0zM13.2 19.81v31.34M13.17 65.1a7 7 0 1 1 7-7"/><path pid="1" class="cls-2" d="M15.16 10.77h4.48"/><path pid="2" class="cls-1" d="M15.17 26.23h4.48M15.17 41.67h4.48M17.42 18.49h2.23M17.42 33.95h2.23"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/temperature.js